import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Form, Row, Col } from "react-bootstrap";
import SearchFilter from "../../../../components/SearchFilter";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import ConfirmModal from "../../../../components/ConfirmModal";
import TableForm2s from "../../../../components/TableFormScrb";
import { getQueryString } from "../../../../utils/Query";
import TechScheduleCusService from "../../../../services/techschedulecus.service";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import { formatDate, formatDateTime } from "../../../../commons/FormatValue";
import moment from "moment";

export default function AddCustomer() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchValue, setSearchValue] = useState([]);
  const [dataModal, setDataModal] = useState({ Array: [] });
  const [showModal, setShowModal] = useState(false);
  const [supTeam, setSupTeam] = useState("");
  const [tableData, setTableData] = useState([]);
  const [validated, setValidated] = useState(false);

  const columns = [
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      format: (row) => formatDate(row?.Tech_Rev_Date),
      readOnly: true
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true,
    },
    {
      name: "Branch_No",
      label: "เลขที่สาขา",
      readOnly: true,
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      width: "200px"
    },
    {
      name: "Job_Actual_Date",
      label: "วันที่เข้างาน",
      readOnly: true,
      format: (row) => formatDate(row?.Job_Actual_Date),
    },
    {
      name: "Tech_Name",
      label: "ผู้ติดต่อ",
      readOnly: true,
    },
    {
      name: "Tech_Tel",
      label: "เบอร์ติดต่อ",
      readOnly: true,
    },
    {
      name: "Appointment_Tel_Date",
      label: "วันเวลาโทรนัดหมาย",
      type: "datetime-local",
      width: "200px"
    },
    {
      name: "Appointment_Date",
      label: "วันเวลานัดหมาย",
      type: "datetime-local",
      width: "200px"
    },
    {
      name: "Work_Actual_Date",
      label: "วันเวลาเข้างานจริง",
      type: "datetime-local",
      width: "200px"
    },
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: supTeam,
      disabled: true,
      size: 3
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: supTeam,
      disabled: true,
      size: 3
    },
    {
      name: "start",
      label: "วันที่นัดหมายระหว่างวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      // value: formatDate(new Date(), "YYYY-MM-DD")
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      min: 'start'
    }
  ];

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  useEffect(() => {
    getData()
  }, []);
  const [querySearch, setQuerySearch] = useState()

  const getData = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({
      ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search?.start),
      end: toFormatISO(search?.end)
    })
    setQuerySearch(q)
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechScheduleCusService.getAllScheduleCustomer(q),
      callback: (res) => { pSetData(res.data); }
    });
  };
  const pSetData = (vData) => {
    const newArray = vData?.map((items) => ({
      Id: items.id,
      Tech_Plan_Id: items.tech_plan_id,
      Seq_No: items.TechnicianPlans.SeqOthersJob?.Seq_Oth_No ||
        items.TechnicianPlans.SeqPmJob?.Seq_Pm_No ||
        items.TechnicianPlans.SeqRepairJob?.Seq_Serv_No ||
        items.TechnicianPlans.SeqInstallJob?.Seq_Inst_No,
      Cus_Code: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Customer.Cus_Code,
      Cus_Name: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Customer.Cus_Name,
      Branch_No: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Cus_NumBranch,
      Job_Actual_Date: formatInputDate(items.TechnicianPlans?.job_actual_date, "Local").date,
      Tech_Name: items.TechnicianPlans?.Technician.Tech_Mas_Name,
      Tech_Tel: items.TechnicianPlans?.Technician.Tech_Mas_Tel,
      Appointment_Tel_Date: formatDateTime(new Date(items.appointment_tel_date), "YYYY-MM-DD HH:mm"),
      Appointment_Date: formatDateTime(new Date(items.appointment_date), "YYYY-MM-DD HH:mm"),
      Work_Actual_Date: formatDateTime(new Date(items.work_actual_date), "YYYY-MM-DD HH:mm")
    }));
    setTableData(newArray);
  };

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      try {
        dataCallback.Array?.forEach(async ele => {
          addEditServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: TechScheduleCusService.editScheduleCustomer(ele.Id, {
              tech_plan_id: ele.Tech_Plan_Id,
              appointment_tel_date: new Date(ele.Appointment_Tel_Date).toISOString(),
              appointment_date: new Date(ele.Appointment_Date).toISOString(),
              work_actual_date: new Date(ele.Work_Actual_Date).toISOString(),
            }),
            navigated: (navi) =>
              navi &&
              navigate("/service_work/acceptance/customer")
          });
        })
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <CardDisplayComponent
        header={{ title: { text: "เพิ่มข้อมูลการติดต่อและนัดหมายลูกค้า" } }}
        cardClassName="text-center"
        body={{
          element: (
            <>
              <SearchFilter
                data={searchInput}
                inputField={searchInput}
                searchCallback={array => {
                  getData({ start: array[2].value || "", end: array[3].value || "" })
                }}
              />
            </>
          )
        }}
      />

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2 text-dark">
            รายละเอียดข้อมูลที่จะติดต่อและนัดหมายลูกค้า
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleValidated}>
            <TableForm2s
              data={tableData}
              columns={columns}
              editForm={true}
              isLoading={loading}
              searchFilter={searchValue}
              pagination={false}
              onChangeCallback={(newData) => {
                const aForSave = newData.filter(d => d.isEdit)
                //   .map((item) => ({
                //     // id: item.Id,
                //     tech_plan_id: item.Tech_Plan_Id,
                //     appointment_tel_date: new Date(item.Appointment_Tel_Date).toISOString(),
                //     appointment_date: new Date(item.Appointment_Date).toISOString(),
                //     work_actual_date: new Date(item.Work_Actual_Date).toISOString(),
                //   }));

                setTableData(newData);
                setDataModal({ Array: aForSave });
              }}
            />
          </Form>
        </Card.Body>

        <Row className="justify-content-end mt-3">
          <Col className="col-auto">
            <Button
              type="submit"
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill"
              onClick={() => setShowModal(!showModal)}
            >
              บันทึกข้อมูล
            </Button>
            <ConfirmModal
              show={showModal}
              data={dataModal}
              content={"save"}
              onSubmitCallback={handleSubmit}
            />
            <Button
              variant="outline-secondary"
              className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
              onClick={() =>
                navigate("/service_work/acceptance/customer")
              }
            >
              ย้อนกลับ
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
}
